if (module.hot) {
  module.hot.accept()
}

require('./styles.css')
require('./main.js')



//////////////////
// WEBPACK FOOTER
// ./src/index.js
// module id = 5
// module chunks = 0